import { render, staticRenderFns } from "./MonthList.vue?vue&type=template&id=2b56c076&scoped=true&"
import script from "./MonthList.vue?vue&type=script&lang=js&"
export * from "./MonthList.vue?vue&type=script&lang=js&"
import style0 from "./MonthList.vue?vue&type=style&index=0&id=2b56c076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56c076",
  null
  
)

export default component.exports